import { useState } from 'react';
import { faqs } from '@/mocks/faqs';
import SchemaOrg from '@/components/base/SchemaOrg';

export default function FAQSection() {
  const [openId, setOpenId] = useState<string | null>(null);

  const toggle = (id: string) => {
    setOpenId(openId === id ? null : id);
  };

  const faqSchema = {
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };

  return (
    <section className="py-16 md:py-20 bg-background-50">
      <SchemaOrg type="FAQPage" data={faqSchema} />
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            常见问题解答
          </h2>
          <p className="text-foreground-600 text-base">
            关于jm天堂的常见疑问，这里都有答案
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq) => (
            <div
              key={faq.id}
              className="bg-background-50 border border-background-200/70 rounded-xl overflow-hidden transition-all duration-300"
            >
              <button
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer hover:bg-background-100/50 transition-colors duration-200"
                onClick={() => toggle(faq.id)}
                aria-expanded={openId === faq.id}
              >
                <span className="font-medium text-foreground-900 pr-4 text-sm md:text-base">
                  {faq.question}
                </span>
                <div className={`w-6 h-6 flex-shrink-0 flex items-center justify-center rounded-full transition-all duration-300 ${
                  openId === faq.id
                    ? 'bg-primary-100 text-primary-600 rotate-45'
                    : 'bg-background-200 text-foreground-500'
                }`}>
                  <i className="ri-add-line text-sm"></i>
                </div>
              </button>
              <div
                className={`transition-all duration-300 overflow-hidden ${
                  openId === faq.id ? 'max-h-[600px] opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <div className="px-5 pb-5 text-sm text-foreground-700 leading-relaxed border-t border-background-200/50 pt-4">
                  {faq.answer}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}